import { render } from "./FormTextControl.vue?vue&type=template&id=328eebd4&scoped=true"
import script from "./FormTextControl.vue?vue&type=script&lang=js"
export * from "./FormTextControl.vue?vue&type=script&lang=js"

import "./FormTextControl.vue?vue&type=style&index=0&id=328eebd4&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-328eebd4"]])

export default __exports__